import Header from "@/components/Header";
import Products from "@/components/Products";
import Footer from "@/components/Footer";
import Contact from "@/components/Contact";
import CookieConsent from "@/components/CookieConsent";
import ErrorBoundary from "@/components/ErrorBoundary";
import Seo from "@/components/Seo";

const Produtos = () => {
  return (
    <div className="min-h-screen bg-background">
      <Seo
        title="Produtos de Cal Virgem e Hidratada | Quimical"
        description="Portfólio de cal virgem calcítica e dolomítica, cal hidratada e soluções para indústria, construção e saneamento."
        canonical="https://quimical.com.br/produtos"
      />
      <ErrorBoundary componentName="Header">
        <Header />
      </ErrorBoundary>
      <main>
        <ErrorBoundary componentName="Products">
          <Products />
        </ErrorBoundary>
        <ErrorBoundary componentName="Contact">
          <Contact />
        </ErrorBoundary>
      </main>
      <ErrorBoundary componentName="Footer">
        <Footer />
      </ErrorBoundary>
      <ErrorBoundary componentName="CookieConsent">
        <CookieConsent />
      </ErrorBoundary>
    </div>
  );
};

export default Produtos;
